import { useEffect, useState } from "react";
import { gsap } from 'gsap/dist/gsap';
import Lottie from "react-lottie-player";
import data from '../../../public/loader/loading.json';

function Loader({loaded, audio, dataAudio, dataAudio2}) {

  const screenWidth = window.innerWidth;
  //console.log(dataAudio);
  useEffect(() => {
    if(loaded) {
      // Play Sound
      if(audio) {
        audio.play();
        // Toggle volume
        gsap.to(audio, {volume: 1, duration: 0.5});
        audio.loop = true;
        // Mute Audio
        //gsap.to(dataAudio, {volume: 0, duration: 0.5});
        //gsap.to(dataAudio2, {volume: 0, duration: 0.5});
      }
      setTimeout(() => {
        document.querySelector(".loader").classList.add("loaded");
        if(audio) {
          gsap.to(audio, {volume: 0, duration: 0.5, onComplete: () => {
            audio.pause();
            // Mute Audio
            //gsap.to(dataAudio, {volume: 1, duration: 0.5});
            //gsap.to(dataAudio2, {volume: 1, duration: 0.5});
          }});
        }
      }, 1500);
    };
  }, [loaded])

  return (
    <div className='loader fixed top-0 left-0 w-screen h-screen z-50 flex justify-center items-center'>
      <div className="overlay absolute top-0 left-0 w-full h-full z-20"></div>
      <div className="animLogo relative z-50">
        <Lottie 
          loop
          animationData={data}
          play
          style={{ width: (screenWidth < 767 ? 300 : 400), height: (screenWidth < 767 ? 250 : 350) }}
        />
      </div>
    </div>
  )
}

export default Loader